/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import HeaderInfo from "../components/common/HeaderInfo";
import DataTable from "../components/common/DataTable";
import { Edit, Delete } from "../components/icons";
import { Eye } from "lucide-react";
import itmImg from "../assets/item-thumbnail.png";
import DeleteModal from "../components/modals/DeleteModal";
import ItemModal from "../components/modals/ItemModal";
import ItemDetailsModal from "../components/modals/ItemDetailsModal";
import {
  useCreateItemMutation,
  useGetAllItemsQuery,
  useUpdateItemMutation,
  useDeleteItemMutation,
} from "../store/api/itemApi";
import {
  useGetAllVendorsQuery,
  useGetCategoriesQuery,
} from "../store/api";

export default function Items() {
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedItem, setSelectedItem] = useState(null);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [detailsId, setDetailsId] = useState(null);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedVendor, setSelectedVendor] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(handler);
  }, [search]);

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch, selectedCategory, selectedVendor]);

  const { data, isLoading, isFetching, error } = useGetAllItemsQuery({
    page,
    name: debouncedSearch,
    ...(selectedCategory && { itemCategory: selectedCategory }),
    ...(selectedVendor && { itemVendor: selectedVendor }),
  });

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.message || "Failed to load items");
    }
  }, [error]);

  const items = data?.data?.items || [];

  const { data: categoriesData, isLoading: categoriesLoading } =
    useGetCategoriesQuery();

  const { data: vendorsData, isLoading: vendorsLoading } =
    useGetAllVendorsQuery(1);

 
  const categories = categoriesData?.data?.categories || [];
  console.log(categories)

  const vendors = vendorsData?.data?.vendors || [];

  const totalPages = data?.data?.pages || 1;

  function handleNext() {
    if (page < totalPages) setPage((p) => p + 1);
  }

  function handlePrev() {
    if (page > 1) setPage((p) => p - 1);
  }

  const [createItem, { isLoading: creating }] = useCreateItemMutation();
  const [updateItem, { isLoading: updating }] = useUpdateItemMutation();
  const [deleteItem, { isLoading: deleting }] = useDeleteItemMutation();

  function handleOpenEdit(row) {
    setSelectedItem(row);
    setModalMode("edit");
    setModalOpen(true);
  }

  function handleOpenAdd() {
    setSelectedItem(null);
    setModalMode("add");
    setModalOpen(true);
  }

  function handleCloseModal() {
    setModalOpen(false);
    setSelectedItem(null);
    setModalMode("add");
  }
  function handleOpenDelete(row) {
    setDeleteRow(row);
    setDeleteOpen(true);
  }
  function handleCloseDelete() {
    setDeleteOpen(false);
    setDeleteRow(null);
  }

  function handleOpenDetails(row) {
    setDetailsId(row._id);
    setDetailsOpen(true);
  }

  function handleCloseDetails() {
    setDetailsOpen(false);
    setDetailsId(null);
  }
  
  const columns =[
    { key: "details", label: "Item Details", className: "col-span-4" },
    { key: "cat", label: "Category", className: "col-span-3" },
    { key: "price", label: "Price", className: "col-span-2" },
    { key: "updated", label: "Last Updated", className: "col-span-2" },
    { key: "actions", label: "Actions", className: "col-span-1 text-right" },
  ];

  const rows = [
    {
      name: "Science Book",
      id: "1F100842",
      category: "Stationary",
      vendor: "General Vendor",
      price: "50",
      updatedDate: "Apr 27, 2026",
      updatedTime: "07:52 PM",
    },
    {
      name: "Science Book",
      id: "1F100842",
      category: "Stationary",
      vendor: "General Vendor",
      price: "50",
      updatedDate: "Apr 27, 2026",
      updatedTime: "07:52 PM",
    },
    {
      name: "Science Book",
      id: "1F100842",
      category: "Stationary",
      vendor: "General Vendor",
      price: "50",
      updatedDate: "Apr 27, 2026",
      updatedTime: "07:52 PM",
    },
    {
      name: "Science Book",
      id: "1F100842",
      category: "Stationary",
      vendor: "General Vendor",
      price: "50",
      updatedDate: "Apr 27, 2026",
      updatedTime: "07:52 PM",
    },
  ];

  const renderRow = (r, idx) => (
    <div
      key={idx}
      className="bg-[#EEEEEE40]"
    >
      <div className="grid grid-cols-12 gap-4 px-7 py-6 items-center border-b border-[#E5E5E5]">
        <div className="col-span-4 flex items-center gap-[14px] text-black">
          <div className="w-[53px] h-[42px]">
            <img
              src={r?.itemPicture?.secure_url || itmImg}
              alt="item"
              className="w-full h-full object-cover"
              onError={(e) => { e.target.onerror = null; e.target.src = itmImg; }}
            />
          </div>
          <div>
            <div className="text-black">{r.name}</div>
            <div className="text-xs leading-4 text-[#8A8A8A]">
              ID: {r._id?.slice(0, 8)}
            </div>
          </div>
        </div>

        <div className="col-span-3">
          <div className="inline-block bg-[#E5FFF6] text-[#2C765C] px-2.5 py-1 rounded-full text-xs capitalize">
            {r.itemCategory.name}
          </div>
        </div>

        <div className="col-span-2 text-black ">Rs {r.itemPrice}</div>

        <div className="col-span-2">
          <div className="text-black">
            {new Date(r.updatedAt).toLocaleDateString("en-US", {
              timeZone: "Asia/Karachi",
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
          </div>
          <div className="text-xs leading-6 text-[#8A8A8A]">
            {new Date(r.updatedAt).toLocaleTimeString("en-US", {
              timeZone: "Asia/Karachi",
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            })}
          </div>
        </div>

        <div className="col-span-1 flex justify-end items-center gap-3">
          <button aria-label="view" onClick={() => handleOpenDetails(r)} className="text-gray-500 hover:text-[#6D4E8A]">
            <Eye size={20} />
          </button>
          <button aria-label="edit" onClick={() => handleOpenEdit(r)}>
            <Edit />
          </button>
          <button aria-label="delete" onClick={() => handleOpenDelete(r)}>
            <Delete />
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="pt-14 pl-8 pr-12 min-h-screen">
      {/* #sym:HeaderInfo */}
      <HeaderInfo
        title="Item Master"
        desc="Centralized control for all inventory products"
        btnLabel="Create New Item"
        isSearchBar={true}
        onAdd={handleOpenAdd}
        searchPlaceholder="Search catalog by item name"
        searchValue={search}
        onSearchChange={setSearch}
        showFilterButton={false}
      />

      <div className="flex flex-wrap items-center gap-4 mt-6 lg:ml-2.5 border border-[#D9D9D9] rounded-[10px] py-3 px-4 bg-[#EEEEEE40]">
        <div className="text-[#878686] font-medium text-sm">Filters:</div>
        <select
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          className="border border-[#D9D9D9] rounded-[8px] py-1.5 px-3 bg-white text-black outline-none text-sm min-w-[200px] capitalize"
        >
          <option value="">All Categories</option>
          {categories.map((c) => (
            <option key={c._id} value={c._id} className="capitalize">{c.name}</option>
          ))}
        </select>

        <select
          value={selectedVendor}
          onChange={(e) => setSelectedVendor(e.target.value)}
          className="border border-[#D9D9D9] rounded-[8px] py-1.5 px-3 bg-white text-black outline-none text-sm min-w-[200px] capitalize"
        >
          <option value="">All Vendors</option>
          {vendors.map((v) => (
            <option key={v._id} value={v._id} className="capitalize">{v.name}</option>
          ))}
        </select>
      </div>

      <div className="mt-6 ml-2.5">
        <DataTable 
          columns={columns} 
          rows={items} 
          renderRow={renderRow} 
          page={page}
          totalPages={totalPages}
          onNext={handleNext}
          onPrev={handlePrev}
          isLoading={isLoading || isFetching}
        />
      </div>

      <ItemModal
        open={modalOpen}
        mode={modalMode}
        initialValues={selectedItem}
        categories={categories}
        vendors={vendors}
        onClose={handleCloseModal}
        onSubmit={async (formData) => {
          try {
            if (modalMode === "add") {
              // Validate required fields
              if (!formData.name || !formData.itemPrice || !formData.itemCategory || !formData.itemVendor) {
                toast.error("Please fill all required fields");
                return;
              }

              const payload = new FormData();
              payload.append("name", formData.name);
              payload.append("itemPrice", parseFloat(formData.itemPrice));
              payload.append("itemCategory", formData.itemCategory);
              payload.append("itemVendor", formData.itemVendor);
              
              if (formData.image) {
                payload.append("image", formData.image);
              }

              // Call the create API
              const response = await createItem(payload).unwrap();
              if (response?.success === false) {
                toast.error(response?.message || "Failed to create item");
                return;
              }
              toast.success("Item created successfully");
              handleCloseModal();
            } else {
              // Edit mode
              if (!selectedItem?._id) {
                toast.error("Item ID not found");
                return;
              }

              const payload = new FormData();
              payload.append("name", formData.name);
              payload.append("itemPrice", parseFloat(formData.itemPrice));
              payload.append("itemCategory", formData.itemCategory);
              payload.append("itemVendor", formData.itemVendor);
              
              if (formData.image) {
                payload.append("image", formData.image);
              }

              const response = await updateItem({
                id: selectedItem._id,
                formData: payload,
              }).unwrap();
              if (response?.success === false) {
                toast.error(response?.message || "Failed to update item");
                return;
              }
              toast.success("Item updated successfully");
              handleCloseModal();
            }
          } catch (err) {
            const errorMessage = err?.data?.message || err?.message || "Failed to process item";
            toast.error(errorMessage);
          }
        }}
      />
      <DeleteModal
        open={deleteOpen}
        onClose={handleCloseDelete}
        onCreate={async () => {
          try {
            if (!deleteRow?._id) {
              console.error("Item ID not found");
              return;
            }

            // Call the delete API
            const response = await deleteItem(deleteRow._id).unwrap();
            if (response?.success === false) {
              toast.error(response?.message || "Failed to delete item");
              return;
            }
            toast.success("Item deleted successfully");
            handleCloseDelete();
          } catch (err) {
            toast.error(err?.data?.message || err.message || "Failed to delete item");
          }
        }}
        modalName="Item"
      />

      <ItemDetailsModal
        open={detailsOpen}
        onClose={handleCloseDetails}
        itemId={detailsId}
      />
    </div>
  );
}
